import * as React from 'react'
import type { SVGProps } from 'react'
const SvgPeople = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={11}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.01193 9.74696L8.01207 8.14008C8.01215 7.25249 7.29264 6.53291 6.40504 6.53291H2.80643C1.91896 6.53291 1.1995 7.25229 1.1994 8.13975L1.19922 9.74696M10.7991 9.74705L10.7992 8.14017C10.7993 7.25257 10.0798 6.53299 9.19219 6.53299M7.70239 1.49185C8.09704 1.78467 8.3528 2.2541 8.3528 2.78326C8.3528 3.31243 8.09703 3.78186 7.70239 4.07467M6.24612 2.78318C6.24612 3.67071 5.52663 4.3902 4.63909 4.3902C3.75155 4.3902 3.03206 3.67071 3.03206 2.78318C3.03206 1.89564 3.75155 1.17615 4.63909 1.17615C5.52663 1.17615 6.24612 1.89564 6.24612 2.78318Z"
      stroke="#616279"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgPeople
